const diagnosticSuffix = (code: string, httpStatus?: number): string => {
    const httpDetail = httpStatus === undefined ? '' : ` / HTTP ${httpStatus}`;
    return `Fehlercode: ${code}${httpDetail}`;
};

export const getLoginFailureMessage = (code: string, httpStatus?: number): string => {
    const diagnostic = diagnosticSuffix(code, httpStatus);

    if (httpStatus === 401) {
        return `Anmeldung fehlgeschlagen. Bitte Code (einschließlich Groß-/Kleinschreibung) und Passwort prüfen. ${diagnostic}`;
    }

    if (httpStatus === 403) {
        return `Die Anmeldung wurde erkannt, aber diesem Konto fehlt der Zugriff. Bitte den Support kontaktieren. ${diagnostic}`;
    }

    if (httpStatus !== undefined && httpStatus >= 500) {
        return `Der Server ist vorübergehend nicht verfügbar. Bitte später erneut versuchen. ${diagnostic}`;
    }

    return `Der Server konnte nicht erreicht werden. Bitte die Internetverbindung prüfen und erneut versuchen. ${diagnostic}`;
};
